import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import Tesseract from 'tesseract.js';
import './Dashboard.css';
import  MediaPlay  from './Media';
import  PdfViewer  from './PdfViewer';
import { getClientIp } from '../utils/clientIp';
import CampanaPush from './CampanaPush';
import CampanaExterna from './CampanaExterna';
import Comisiones from './Comisiones';
import OfertasAdmin from './OfertasAdmin';
import CrmUsuariosAdmin from './CrmUsuariosAdmin';
import CrmMonitoreo from './CrmMonitoreo';
import CompraSaldo from './CompraSaldo';
import AdminLineas from './AdminLineas';
import CRM from './CRM';
import MonkeyGame from './MonkeyGame';
import GameStats from './GameStats';
import Glosario from './Glosario';


import { ToastContainer, toast } from 'react-toastify';
const videoKey = 'media/pruebaw.mp4';
const videoKey2 = 'media/pruebaw2.mp4';
//const [isLoading, setIsLoading] = useState(
//const [isLoading, setIsLoading] = useState(false);

const Dashboard = () => {
  const [username, setUsername] = useState(null);
  const [id_vendedor, setIdvendedor] = useState(null);
  // Si el usuario tiene idvendedor_crm, el CRM y reportes muestran los datos de ESE vendedor
  const [idvendedor_crm, setIdvendedorCrm] = useState('');
  // rol del usuario ('admin' o 'vendedor'); controla la visibilidad de los paneles de administracion
  const [rol, setRol] = useState('');
  const [saldo, setSaldo] = useState(null);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [imei, setimei] = useState('');
  const [icc, seticc] = useState('');
  const [activeView, setActiveView] = useState(null);
  const [scannerStarted, setScannerStarted] = useState(false);
  const [scanning, setScanning] = useState(false);
  const [scanTarget, setScanTarget] = useState('imei'); // 'imei' o 'icc'
  const [zoom, setZoom] = useState(1);
  const scannerRef = useRef(null);
  const imeiInputRef = useRef(null);
  const iccInputRef = useRef(null);
  const ocrIntervalRef = useRef(null);
  const videoTrackRef = useRef(null);
  const scanTargetRef = useRef('imei');
  const [portabilidad, setPortabilidad] = useState(false);
  const [nip, setNip] = useState('');
  const [numeroPortar, setNumeroPortar] = useState('');
  const [procesando, setProcesando] = useState(null); // 'imei' | 'icc' | null
  const [iccStatus, setIccStatus] = useState(null); // 'idle' | 'error' | null
  const [iccInfo, setIccInfo] = useState(null);
  const [imeiInfo, setImeiInfo] = useState(null); // info de homologación
  const [activacionExito, setActivacionExito] = useState(null); // 'activacion' | 'portabilidad' | null
  const [mesSeleccionado, setMesSeleccionado] = useState('todos');
  const [apiData, setApiData] = useState(''  );

  
  useEffect(() => {
    const storedUsername = localStorage.getItem('nombre');
    const storedIdvendedor = localStorage.getItem('id_vendedor');
    const storedCrm = localStorage.getItem('idvendedor_crm');
    if (storedUsername) {
      setUsername(storedUsername);
      setIdvendedor(storedIdvendedor);
      const crm = storedCrm && storedCrm !== 'undefined' && storedCrm !== 'null' ? storedCrm : '';
      setIdvendedorCrm(crm);
      setRol(localStorage.getItem('rol') || '');
      // Usuarios con idvendedor_crm solo usan el CRM: abrirlo directo y sin panel de vendedor
      if (crm) {
        setActiveView('crm');
      }
    }
    // Capturar la IP publica del usuario final (se cachea en localStorage)
    getClientIp();
  }, []);

  // esAdmin: true si el rol es admin/superadmin o es el id_vendedor 9 (legacy). Se recalcula por render.
  const esAdmin = (rol === 'admin' || rol === 'superadmin' || String(id_vendedor) === '9');
  // verTodo: superadmin (o el 9 legacy) ve TODOS los vendedores en reportes/monitoreo.
  const verTodo = (rol === 'superadmin' || String(id_vendedor) === '9');

  const handleSaldoClick = async (event) => {
    event.preventDefault();
    setActiveView('saldo');
    try {
      const data = { id_vendedor, app: '1' };
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/prod/saldo`, data);
      setSaldo(response.data.saldo);
    } catch (error) {
      console.error('Error al consultar saldo:', error);
    }
  };

  const handleReportesClick = async (event) => {
    event.preventDefault();
    setActiveView('reportes');
    try {
      // Si hay idvendedor_crm, los reportes son del vendedor del CRM (ej. 80); si no, del propio vendedor.
      // RESPETA idvendedor_crm: un superadmin con CRM asignado NO es ver-todo.
      const idReportes = idvendedor_crm || id_vendedor;
      const data = { idvendedor: idReportes, app: '1', id: '140', ver_todo: (verTodo && !idvendedor_crm) ? '1' : '0' };
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/prod/`, data);
      const all = Array.isArray(response.data) ? response.data : [];
      setOptions(all);
    } catch (error) {
      console.error('Error al consultar reportes:', error);
    }
  };

  const handleTransactionChange = (e) => {
    const selectedId = e.target.value;
    setSelectedOption(selectedId);
    const transaction = options.find(item => item.folioventa === selectedId);
    setSelectedTransaction(transaction);
  };

  const handleActivacionClick = async (event) => {
    event.preventDefault();
    setActiveView('activacion');
    try {
      const data = { idvendedor: id_vendedor, app: '1', id: '140' };
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/prod/ofertasapp`, data);
//console.log(response);

     // setApiData(response.data);
         
   
///      const data2 = response.data;
      //const fecha=data2.effectiveDate
      //console.log(fecha);

      const responseBody = typeof response.data.body === 'string'
      ? JSON.parse(response.data.body)
      : response.data.body;

    const infoArray = responseBody.info;

    console.log('Arreglo info:', infoArray);
    setOptions(infoArray);   
      //console.log(data2)
     //const flattenedOptions = data2.body.flatMap(info => info);
  //    const msisdn=data2.msisdn
   //  console.log(flattenedOptions);
      //console.log(msisdn);
      //setAdditionalData(msisdn);      
      //setOptions(flattenedOptions);   

     // setOptions(response.data);

   // setApiData(infoArray);



    } catch (error) {
      console.error('Error al consultar reportes:', error);
    } 


  };

  const handleActivacionSubmit = async (e) => {
    e.preventDefault();

    if (iccStatus !== 'idle') {
      toast.warn('Valida el ICCID primero');
      return;
    }

    if (!selectedOption) {
      toast.warn('Selecciona una oferta');
      return;
    }

    // Buscar la oferta seleccionada para obtener el precio
    const ofertaSel = options.find(o => String(o.idoferta_app) === String(selectedOption));

    const clientIp = await getClientIp();

    // Si el usuario tiene idvendedor_crm (ej. 80), la venta se atribuye a ESE vendedor
    const idVenta = idvendedor_crm || id_vendedor;

    const payload = {
      be_id: "",
      be_id2: "140",
      ip: clientIp,
      data: {
        msisdn: icc,
        address: "",
        startEffectiveDate: "",
        expireEffectiveDate: "",
        offeringid: "",
        idoferta_app: selectedOption,
        idpos: "",
        msisdnPorted: "",
        id_vendedor: idVenta,
        saldo_necesario: ofertaSel?.precio_minorista || "",
        coordenadasVenta: "",
        imsi: "",
        icc: icc,
        ip: clientIp,
        portIn: {
          nip: portabilidad ? nip : "",
          msisdnPorted: portabilidad ? numeroPortar : "",
          nombreOperadoraOrigen: "",
          fecha_portacion: ""
        }
      }
    };

    try {
      toast.info('Enviando activación...', { autoClose: 2000 });
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}/prod/activacion`, payload);
      const result = response.data;
      const body = typeof result.body === 'string' ? JSON.parse(result.body) : result.body;
      const statusCode = result.statusCode || response.status;
      const location = body?.location || '';
      const paymentId = body?.payment_request_id || '';

      if (String(statusCode) === '200') {
        if (location === 'clip' && paymentId) {
          window.location.href = `https://pago.clip.mx/${paymentId}`;
        } else if (portabilidad) {
          setActivacionExito('portabilidad');
          toast.success('Portabilidad en proceso. En unos minutos estará lista.');
        } else {
          setActivacionExito('activacion');
          toast.success('Activación en proceso. En unos minutos estará lista.');
          // Redirigir a Altán para vincular la línea después de 3 segundos
          setTimeout(() => {
            window.open('https://rnu.altanredes.com/addomv/vinculatulinea', '_blank');
          }, 3000);
        }
      } else {
        toast.error('Error en la activación. Intenta de nuevo.');
      }
    } catch (error) {
      console.error('Error activación:', error);
      toast.error('Error al enviar la activación');
    }
  };

  // Flujo: abre cámara → usuario apunta → toca capturar → Rekognition
  const abrirCamara = async (target) => {
    scanTargetRef.current = target;
    setScanTarget(target);

    if (!scannerStarted) {
      setScannerStarted(true);
      setScanning(true);

      const html5QrCode = new Html5Qrcode("reader");
      scannerRef.current = html5QrCode;

      try {
        await html5QrCode.start(
          { facingMode: "environment" },
          { fps: 10, qrbox: { width: 300, height: 150 } },
          () => {},
          () => {}
        );
        // Aplicar zoom si es posible
        const video = document.querySelector("video");
        if (video && video.srcObject) {
          const [track] = video.srcObject.getVideoTracks();
          videoTrackRef.current = track;
          const caps = track.getCapabilities();
          if (caps.zoom) {
            const z = Math.min(caps.zoom.max, caps.zoom.min + (caps.zoom.max - caps.zoom.min) * 0.7);
            track.applyConstraints({ advanced: [{ zoom: z }] });
            setZoom(z);
          }
        }
      } catch (err) {
        console.error("Error al iniciar cámara:", err);
        toast.error("No se pudo acceder a la cámara");
        setScannerStarted(false);
        setScanning(false);
      }
    }
  };

  const capturarYEnviar = async () => {
    const target = scanTargetRef.current;
    setProcesando(target);

    const video = document.querySelector("video");
    if (!video) {
      toast.warn("No se encontró la cámara");
      setProcesando(null);
      return;
    }

    // Capturar a resolución reducida para no exceder límite de API Gateway
    const maxWidth = 800;
    const scale = Math.min(maxWidth / video.videoWidth, 1);
    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth * scale;
    canvas.height = video.videoHeight * scale;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Comprimir a JPEG calidad 0.7 para reducir tamaño
    const dataUrl = canvas.toDataURL("image/jpeg", 0.7);

    console.log("Tamaño imagen (aprox KB):", Math.round(dataUrl.length * 0.75 / 1024));

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/prod/rekognition_text`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ image: dataUrl }),
      });

      if (!response.ok) {
        console.error("HTTP error:", response.status);
        toast.error(`Error del servidor: ${response.status}`);
        setProcesando(null);
        return;
      }

      const result = await response.json();
      console.log("Respuesta completa:", result);

      const body = typeof result.body === "string" ? JSON.parse(result.body) : result.body || result;
      const numbers = body.numbers || [];
      const allTexts = body.all_texts || [];

      console.log("Textos detectados:", allTexts);
      console.log("Números filtrados:", numbers);

      if (numbers.length === 0) {
        toast.warn("No se detectó número. Acerca más la tarjeta e intenta de nuevo.");
        setProcesando(null);
        return;
      }

      if (target === "imei") {
        const imeiNum = numbers.find((n) => n.length >= 14 && n.length <= 16) || numbers[0];
        setimei(imeiNum);
        toast.success(`IMEI detectado: ${imeiNum}`);
      } else {
        const sorted = [...numbers].sort((a, b) => b.length - a.length);
        const iccNum = sorted.find((n) => n.length >= 18) || sorted[0];
        seticc(iccNum);
        toast.success(`ICCID detectado: ${iccNum}`);
      }
    } catch (error) {
      console.error("Error Rekognition:", error);
      toast.error("Error de conexión. Revisa tu internet e intenta de nuevo.");
    } finally {
      setProcesando(null);
    }
  };



  const handleChange2 = (event) => {
    setSelectedOption(event.target.value);

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Obtener la URL del API desde las variables de entorno
      const apiUrl = process.env.REACT_APP_API_URL;
      const data = {

        app: "1",
        "serv": "profile"
      };
      toast.success('¡Consulta realizandose !, si has recargado puede tardar unos minutos ');
      localStorage.setItem('formData', JSON.stringify(data));
      //console.log('Guardado:', JSON.parse(localStorage.getItem('formData'))); 
      console.log(data); 
      // Realizar la solicitud POST
      const response = await axios.post(`${apiUrl}/prod/ofertasapp`, data);
      console.log(response)
 

     setApiData(response.data);
      

      const data2 = response.data;

      console.log(data2)
      const flattenedOptions = data2.info.flatMap(info => info);
      //const msisdn=data2.msisdn
      //console.log(flattenedOptions);
      //console.log(msisdn);
     // setAdditionalData(msisdn);      
      setOptions(flattenedOptions);   

    } catch (error) {
      toast.error('Error al enviar el formulario.');
    } finally {
      //setIsLoading(false);
    }
  };




  const applyZoom = (factor) => {
    if (videoTrackRef.current) {
      const capabilities = videoTrackRef.current.getCapabilities();
      if (capabilities.zoom) {
        const newZoom = Math.min(capabilities.zoom.max, Math.max(capabilities.zoom.min, factor));
        videoTrackRef.current.applyConstraints({ advanced: [{ zoom: newZoom }] });
        setZoom(newZoom);
      }
    }
  };

  const startScanner = async (target = 'imei') => {
    if (scannerStarted) return;
    setScanTarget(target);
    scanTargetRef.current = target;
    setScannerStarted(true);
    setScanning(true);

    const config = { fps: 10, qrbox: { width: 250, height: 250 } };
    const html5QrCode = new Html5Qrcode("reader");
    scannerRef.current = html5QrCode;

    html5QrCode.start(
      { facingMode: "environment" },
      config,
      (decodedText) => {
        if (/^\d{1,20}$/.test(decodedText)) {
          if (scanTargetRef.current === 'imei') {
            setimei(decodedText);
            if (imeiInputRef.current) imeiInputRef.current.value = decodedText;
            toast.success(`IMEI detectado: ${decodedText}`);
            // Parar y preparar para ICC
            stopScanner();
            setTimeout(() => setScanTarget('icc'), 300);
            scanTargetRef.current = 'icc';
          } else {
            seticc(decodedText);
            if (iccInputRef.current) iccInputRef.current.value = decodedText;
            toast.success(`ICCID detectado: ${decodedText}`);
            stopScanner();
          }
        }
      },
      (errorMessage) => {
        // silenciar errores de escaneo continuo
      }
    ).then(() => {
      const video = document.querySelector("video");
      if (video && video.srcObject) {
        const [track] = video.srcObject.getVideoTracks();
        videoTrackRef.current = track;
        const capabilities = track.getCapabilities();
        if (capabilities.zoom) {
          const defaultZoom = capabilities.zoom.max * 0.9;
          track.applyConstraints({ advanced: [{ zoom: defaultZoom }] });
          setZoom(defaultZoom);
        }
      }
    }).catch(err => {
      console.error("Error al iniciar el escáner:", err);
      setScannerStarted(false);
      setScanning(false);
    });

    ocrIntervalRef.current = setInterval(() => handleOCR(), 5000);
  };

  const stopScanner = () => {
    if (scannerRef.current) {
      scannerRef.current.stop().then(() => {
        scannerRef.current.clear();
        setScannerStarted(false);
        setScanning(false);
        clearInterval(ocrIntervalRef.current);
      }).catch(err => {
        console.error("Error al detener el escáner:", err);
      });
    }
  };

  const handleOCR = async () => {
    const videoElement = document.querySelector('video');
    if (!videoElement) return;

    const canvas = document.createElement('canvas');
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
    const context = canvas.getContext('2d');
    context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL('image/png');
    try {
      const { data: { text } } = await Tesseract.recognize(dataUrl, 'eng');
      const match = text.match(/\d{14,20}/);
      if (match) {
        const detected = match[0];
        if (scanTargetRef.current === 'imei') {
          setimei(detected);
          if (imeiInputRef.current) imeiInputRef.current.value = detected;
          toast.success(`IMEI detectado (OCR): ${detected}`);
          stopScanner();
          scanTargetRef.current = 'icc';
          setScanTarget('icc');
        } else {
          seticc(detected);
          if (iccInputRef.current) iccInputRef.current.value = detected;
          toast.success(`ICCID detectado (OCR): ${detected}`);
          stopScanner();
        }
      }
    } catch (err) {
      console.error('Error OCR:', err);
    }
  };

  const enviarARekognition = async (target) => {
    const video = document.querySelector("video");
    if (!video) {
      toast.warn("Inicia el escáner primero para capturar la imagen");
      return;
    }

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
    const dataUrl = canvas.toDataURL("image/jpeg");

    toast.info("Analizando imagen...", { autoClose: 2000 });

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/prod/rekognition_text`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ image: dataUrl }),
      });

      const result = await response.json();
      const body = typeof result.body === "string" ? JSON.parse(result.body) : result.body;
      const numbers = body.numbers || [];

      if (numbers.length === 0) {
        toast.warn("No se detectó ningún número válido. Intenta de nuevo.");
        return;
      }

      const scanFor = target || scanTargetRef.current;

      if (scanFor === "imei") {
        // IMEI: 15 dígitos típicamente
        const imeiNum = numbers.find((n) => n.length >= 14 && n.length <= 16) || numbers[0];
        setimei(imeiNum);
        if (imeiInputRef.current) imeiInputRef.current.value = imeiNum;
        toast.success(`IMEI detectado: ${imeiNum}`);
        scanTargetRef.current = "icc";
        setScanTarget("icc");
      } else {
        // ICCID: 19-20 dígitos típicamente
        const iccNum = numbers.find((n) => n.length >= 18) || numbers[0];
        seticc(iccNum);
        if (iccInputRef.current) iccInputRef.current.value = iccNum;
        toast.success(`ICCID detectado: ${iccNum}`);
      }
    } catch (error) {
      console.error("Error Rekognition:", error);
      toast.error("Error al analizar la imagen");
    }
  };

  // Validar IMEI contra API de homologación
  const validarImei = async (imeiValue) => {
    setImeiInfo(null);
    try {
      const response = await fetch('https://6ysg6yqfv4.execute-api.us-east-1.amazonaws.com/prod/imei', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imei: imeiValue, serv: 'imei', id_vendedor: id_vendedor || '0' }),
      });
      const result = await response.json();
      const body = typeof result.body === 'string' ? JSON.parse(result.body) : result.body || result;
      const r = body.result || body;

      setImeiInfo({
        status: r.homologated || body.status || 'No disponible',
        homologated: r.homologated || body.homologated || 'No disponible',
        brand: r.brand || '',
        model: r.model || '',
        band28: r.band28_support || '',
        esim: r.esim || '',
      });
      toast.info(`IMEI: ${r.brand || ''} ${r.model || ''} — ${r.homologated || ''}`);
    } catch (err) {
      console.error('Error validando IMEI:', err);
      setImeiInfo({ status: 'Error', homologated: 'Error al consultar' });
    }
  };

  // Validar ICCID contra profile2
  const validarIcc = async (iccValue) => {
    setIccStatus(null);
    setIccInfo(null);
    try {
      const response = await fetch('https://skeuoyitdc.execute-api.mx-central-1.amazonaws.com/prod/profile2', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ msisdn: iccValue, serv: 'profile' }),
      });
      const result = await response.json();
      const body = typeof result.body === 'string' ? JSON.parse(result.body) : result.body;
      const estatus = String(body?.estatus || '');

      if (estatus === 'Idle') {
        setIccStatus('idle');
        setIccInfo(body);
        toast.success('✅ ICCID válido — Estatus: Idle');
      } else {
        setIccStatus('error');
        setIccInfo(null);
        toast.error(`❌ ICCID no válido — Estatus: ${estatus || 'desconocido'}. Debe estar Idle.`);
      }
    } catch (err) {
      console.error('Error validando ICC:', err);
      setIccStatus('error');
      toast.error('Error al validar el ICCID');
    }
  };

  // Procesar foto de la cámara nativa → Rekognition
  const procesarFoto = async (e, target) => {
    const file = e.target.files[0];
    if (!file) return;
    // Limpiar el input para poder volver a seleccionar la misma foto
    e.target.value = '';

    setProcesando(target);

    try {
      // Leer y redimensionar la imagen
      const dataUrl = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (ev) => {
          const img = new Image();
          img.onload = () => {
            const maxW = 1024;
            const scale = Math.min(maxW / img.width, 1);
            const canvas = document.createElement('canvas');
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(canvas.toDataURL('image/jpeg', 0.8));
          };
          img.src = ev.target.result;
        };
        reader.readAsDataURL(file);
      });

      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${apiUrl}/prod/rekognition_text`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: dataUrl }),
      });

      if (!response.ok) {
        toast.error(`Error del servidor: ${response.status}`);
        return;
      }

      const result = await response.json();
      const body = typeof result.body === 'string' ? JSON.parse(result.body) : result.body || result;
      const numbers = body.numbers || [];

      console.log('Textos:', body.all_texts);
      console.log('Números:', numbers);

      if (numbers.length === 0) {
        toast.warn('No se detectó número. Toma la foto más cerca.');
        return;
      }

      if (target === 'imei') {
        const num = numbers.find((n) => n.length >= 14 && n.length <= 16) || numbers[0];
        setimei(num);
        toast.success(`IMEI: ${num}`);
        await validarImei(num);
      } else {
        const sorted = [...numbers].sort((a, b) => b.length - a.length);
        const num = sorted.find((n) => n.length >= 18) || sorted[0];
        seticc(num);
        toast.success(`ICCID: ${num}`);
        // Validar automáticamente
        await validarIcc(num);
      }
    } catch (err) {
      console.error('Error:', err);
      toast.error('Error al procesar la imagen');
    } finally {
      setProcesando(null);
    }
  };

  return (
    <div className="content-container">
      <div className="absolute-container2">
        {username ? (
          <>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <h2 style={{ color: '#1b2938', margin: '0 0 4px 0' }}>Hola, {username}</h2>
              <p style={{ color: '#6b7280', fontSize: '14px', margin: 0 }}>{idvendedor_crm ? 'CRM de líneas' : 'Panel de vendedor'}</p>
            </div>

            {!idvendedor_crm && (
            <div style={
              activeView === 'crm'
                ? { display: 'flex', gap: '8px', marginBottom: '14px', overflowX: 'auto', paddingBottom: '4px' }
                : { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '20px' }
            }
            className={activeView === 'crm' ? 'botones-mini' : ''}>
              <button onClick={handleSaldoClick} style={{
                padding: '18px 10px', background: activeView === 'saldo' ? '#1b2938' : '#fff',
                color: activeView === 'saldo' ? '#fff' : '#1b2938',
                border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                textAlign: 'center', fontSize: '12px', fontWeight: '600',
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>💰</div>
                Saldo
              </button>
              <button onClick={handleReportesClick} style={{
                padding: '18px 10px', background: activeView === 'reportes' ? '#1b2938' : '#fff',
                color: activeView === 'reportes' ? '#fff' : '#1b2938',
                border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                textAlign: 'center', fontSize: '12px', fontWeight: '600',
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>📊</div>
                Reportes
              </button>
              <button onClick={handleActivacionClick} style={{
                padding: '18px 10px', background: activeView === 'activacion' ? '#1b2938' : '#fff',
                color: activeView === 'activacion' ? '#fff' : '#1b2938',
                border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                textAlign: 'center', fontSize: '12px', fontWeight: '600',
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>📱</div>
                Activación
              </button>
              <button onClick={async () => {
                setActiveView('compra_saldo');
                if (!saldo) {
                  try {
                    const apiUrl = process.env.REACT_APP_API_URL;
                    const response = await axios.post(`${apiUrl}/prod/saldo`, { id_vendedor, app: '1' });
                    setSaldo(response.data.saldo);
                  } catch (error) {
                    console.error('Error al consultar saldo:', error);
                  }
                }
              }} style={{
                padding: '18px 10px', background: activeView === 'compra_saldo' ? '#1a3a2a' : '#fff',
                color: activeView === 'compra_saldo' ? '#fff' : '#1a3a2a',
                border: '1px solid #d4e8d6', borderRadius: '14px', cursor: 'pointer',
                textAlign: 'center', fontSize: '12px', fontWeight: '600',
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>💳</div>
                Comprar Saldo
              </button>
              <button onClick={() => setActiveView('glosario')} style={{
                padding: '18px 10px', background: activeView === 'glosario' ? '#1a3a2a' : '#fff',
                color: activeView === 'glosario' ? '#fff' : '#1a3a2a',
                border: '1px solid #d4e8d6', borderRadius: '14px', cursor: 'pointer',
                textAlign: 'center', fontSize: '12px', fontWeight: '600',
              }}>
                <div style={{ fontSize: '22px', marginBottom: '6px' }}>📖</div>
                Guía
              </button>
              {(esAdmin || String(id_vendedor) === '80' || idvendedor_crm) && (
                <button onClick={() => setActiveView('crm')} style={{
                  padding: '18px 10px', background: activeView === 'crm' ? '#0b3d2e' : '#fff',
                  color: activeView === 'crm' ? '#fff' : '#0b3d2e',
                  border: '1px solid #cfe3d8', borderRadius: '14px', cursor: 'pointer',
                  textAlign: 'center', fontSize: '12px', fontWeight: '600',
                }}>
                  <div style={{ fontSize: '22px', marginBottom: '6px' }}>🗂️</div>
                  CRM
                </button>
              )}
              {esAdmin && (
                <>
                  <button onClick={() => setActiveView('campana')} style={{
                    padding: '18px 10px', background: activeView === 'campana' ? '#1b2938' : '#fff',
                    color: activeView === 'campana' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>📢</div>
                    Campañas
                  </button>
                  <button onClick={() => setActiveView('redes')} style={{
                    padding: '18px 10px', background: activeView === 'redes' ? '#1b2938' : '#fff',
                    color: activeView === 'redes' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>📸</div>
                    Redes
                  </button>
                  <button onClick={() => setActiveView('comisiones')} style={{
                    padding: '18px 10px', background: activeView === 'comisiones' ? '#1b2938' : '#fff',
                    color: activeView === 'comisiones' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>💎</div>
                    Comisiones
                  </button>
                  <button onClick={() => setActiveView('ofertas_admin')} style={{
                    padding: '18px 10px', background: activeView === 'ofertas_admin' ? '#1b2938' : '#fff',
                    color: activeView === 'ofertas_admin' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>🍌</div>
                    Ofertas
                  </button>
                  <button onClick={() => setActiveView('game_stats')} style={{
                    padding: '18px 10px', background: activeView === 'game_stats' ? '#1b2938' : '#fff',
                    color: activeView === 'game_stats' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>🎮</div>
                    Stats Juego
                  </button>
                  <button onClick={() => setActiveView('admin_lineas')} style={{
                    padding: '18px 10px', background: activeView === 'admin_lineas' ? '#1b2938' : '#fff',
                    color: activeView === 'admin_lineas' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>📲</div>
                    Líneas
                  </button>
                  <button onClick={() => setActiveView('crm_usuarios')} style={{
                    padding: '18px 10px', background: activeView === 'crm_usuarios' ? '#1b2938' : '#fff',
                    color: activeView === 'crm_usuarios' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>👥</div>
                    Usuarios CRM
                  </button>
                  <button onClick={() => setActiveView('monitoreo')} style={{
                    padding: '18px 10px', background: activeView === 'monitoreo' ? '#1b2938' : '#fff',
                    color: activeView === 'monitoreo' ? '#fff' : '#1b2938',
                    border: '1px solid #e2e8f0', borderRadius: '14px', cursor: 'pointer',
                    textAlign: 'center', fontSize: '12px', fontWeight: '600',
                  }}>
                    <div style={{ fontSize: '22px', marginBottom: '6px' }}>🔎</div>
                    Monitoreo del día
                  </button>
                </>
              )}
            </div>
            )}
          </>
        ) : (
          <h1>No se encontró ningún usuario.</h1>
        )}

        {activeView === 'saldo' && saldo && (
          <div>
            {/* Tarjeta de saldo */}
            <div style={{
              background: 'linear-gradient(135deg, #1b2938, #2a4a6b)',
              borderRadius: '20px',
              padding: '32px 24px',
              textAlign: 'center',
              color: '#fff',
              marginBottom: '20px',
            }}>
              <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', margin: '0 0 8px 0' }}>Saldo disponible</p>
              <h1 style={{ fontSize: '3rem', fontWeight: '800', margin: '0 0 4px 0' }}>$ {saldo}</h1>
              <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)', margin: 0 }}>MXN</p>
            </div>

            {/* Acciones rápidas */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
              <button onClick={handleReportesClick} style={{
                padding: '16px', background: '#fff', border: '1px solid #e2e8f0',
                borderRadius: '14px', cursor: 'pointer', textAlign: 'center',
              }}>
                <div style={{ fontSize: '24px', marginBottom: '6px' }}>📊</div>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#1b2938' }}>Ver Reportes</div>
              </button>
              <button onClick={handleActivacionClick} style={{
                padding: '16px', background: '#fff', border: '1px solid #e2e8f0',
                borderRadius: '14px', cursor: 'pointer', textAlign: 'center',
              }}>
                <div style={{ fontSize: '24px', marginBottom: '6px' }}>📱</div>
                <div style={{ fontSize: '13px', fontWeight: '600', color: '#1b2938' }}>Activar Línea</div>
              </button>
            </div>

            {/* Info */}
            <div style={{
              background: '#e8f0fe', borderRadius: '14px', padding: '14px 18px',
              fontSize: '13px', color: '#1b2938', textAlign: 'center',
            }}>
              💡 Tu saldo se descuenta automáticamente al activar líneas sin pago con Clip.
            </div>
          </div>
        )}

        {activeView === 'reportes' && (() => {
          // Extraer meses disponibles
          const meses = [...new Set(options.map(i => {
            const d = i.fecha ? i.fecha.substring(0, 7) : '';
            return d;
          }).filter(Boolean))].sort().reverse();

          const filtered = mesSeleccionado === 'todos'
            ? options
            : options.filter(i => i.fecha && i.fecha.startsWith(mesSeleccionado));

          const descargarCSV = () => {
            const headers = ['Folio', 'Fecha', 'Estatus', 'Oferta', 'Número', 'Tipo', 'ICCID', 'SKU'];
            const rows = filtered.map(i => [i.folioventa, i.fecha, i.Estatus, i.oferta, i.msisdn, i.trans, i.iccid || '', i.sku || '']);
            const csv = [headers, ...rows].map(r => r.join(',')).join('\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `reporte_${mesSeleccionado}.csv`;
            a.click();
            URL.revokeObjectURL(url);
          };

          return (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
              <h2 style={{ color: '#1b2938', margin: 0 }}>📊 Reportes de Ventas</h2>
              <div style={{ display: 'flex', gap: '8px' }}>
                <select
                  value={mesSeleccionado}
                  onChange={(e) => setMesSeleccionado(e.target.value)}
                  style={{ padding: '8px 12px', borderRadius: '10px', border: '1px solid #ccc', fontSize: '13px' }}
                >
                  <option value="todos">Todos los meses</option>
                  {meses.map(m => (
                    <option key={m} value={m}>{m}</option>
                  ))}
                </select>
                <button
                  onClick={descargarCSV}
                  style={{ padding: '8px 16px', borderRadius: '10px', background: '#1b2938', color: '#fff', border: 'none', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}
                >
                  📥 CSV
                </button>
              </div>
            </div>

            {/* Resumen */}
            {filtered.length > 0 && (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '20px' }}>
                <div style={{ background: '#e8f0fe', borderRadius: '14px', padding: '16px', textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: '800', color: '#1b2938' }}>{filtered.length}</div>
                  <div style={{ fontSize: '12px', color: '#4b5563' }}>Total</div>
                </div>
                <div style={{ background: '#dcfce7', borderRadius: '14px', padding: '16px', textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: '800', color: '#166534' }}>
                    {filtered.filter(i => /exitosa|activ/i.test(i.Estatus)).length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#4b5563' }}>Exitosas</div>
                </div>
                <div style={{ background: '#fef3c7', borderRadius: '14px', padding: '16px', textAlign: 'center' }}>
                  <div style={{ fontSize: '24px', fontWeight: '800', color: '#92400e' }}>
                    {filtered.filter(i => !/exitosa|activ/i.test(i.Estatus)).length}
                  </div>
                  <div style={{ fontSize: '12px', color: '#4b5563' }}>Pendientes</div>
                </div>
              </div>
            )}

            {/* Lista */}
            {filtered.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '30px', color: '#9ca3af' }}>No hay transacciones</div>
            ) : (
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {filtered.map((item) => (
                  <div
                    key={item.folioventa}
                    onClick={() => { setSelectedOption(item.folioventa); setSelectedTransaction(item); }}
                    style={{
                      background: selectedOption === item.folioventa ? '#e8f0fe' : '#fff',
                      border: selectedOption === item.folioventa ? '2px solid #0056b3' : '1px solid #e2e8f0',
                      borderRadius: '14px',
                      padding: '14px 16px',
                      marginBottom: '10px',
                      cursor: 'pointer',
                      transition: 'all 0.15s',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                      <span style={{ fontWeight: '700', fontSize: '14px', color: '#1b2938' }}>#{item.folioventa}</span>
                      <span style={{
                        fontSize: '11px', fontWeight: '600', padding: '3px 10px', borderRadius: '20px',
                        background: /exitosa|activ/i.test(item.Estatus) ? '#dcfce7' : '#fef3c7',
                        color: /exitosa|activ/i.test(item.Estatus) ? '#166534' : '#92400e',
                      }}>
                        {item.Estatus}
                      </span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#4b5563' }}>
                      📞 {item.msisdn} · 📦 {item.oferta} · {item.trans}
                    </div>
                    <div style={{ fontSize: '12px', color: '#9ca3af', marginTop: '4px' }}>📅 {item.fecha}</div>
                    {selectedTransaction && selectedOption === item.folioventa && (
                      <div style={{ marginTop: '10px', padding: '10px', background: '#f0f4f8', borderRadius: '10px', fontSize: '13px' }}>
                        <div><strong>ICCID:</strong> {selectedTransaction.iccid}</div>
                        <div><strong>SKU:</strong> {selectedTransaction.sku}</div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
          );
        })()}

        {activeView === 'activacion' && (
          <form onSubmit={handleActivacionSubmit} className="activation-form">
            <h2>Activación</h2>

            {/* IMEI */}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '4px' }}>
              <input
                placeholder="IMEI (opcional, marca *#06#)"
                type="text"
                value={imei}
                onChange={(e) => {
                  setimei(e.target.value);
                  setImeiInfo(null);
                }}
                onBlur={() => { if (imei.length >= 14) validarImei(imei); }}
                style={{
                  flex: 1,
                  borderColor: imeiInfo ? '#1b2938' : undefined,
                  borderWidth: imeiInfo ? '2px' : undefined,
                }}
              />
              <button
                type="button"
                className="orange-button small-button"
                onClick={() => { if (imei.length >= 14) validarImei(imei); else toast.warn('Ingresa un IMEI válido'); }}
                disabled={procesando !== null}
                style={{ margin: 0 }}
              >
                ✓
              </button>
              <label className="orange-button small-button" style={{ cursor: 'pointer', textAlign: 'center', margin: 0 }}>
                {procesando === 'imei' ? '⏳...' : '📷'}
                <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  style={{ display: 'none' }}
                  onChange={(e) => procesarFoto(e, 'imei')}
                />
              </label>
            </div>
            {imeiInfo && (
              <div style={{
                fontSize: '13px',
                fontWeight: 'bold',
                marginBottom: '10px',
                color: '#1b2938',
                background: '#f0f4f8',
                padding: '10px 12px',
                borderRadius: '8px',
                lineHeight: '1.6',
              }}>
                {imeiInfo.brand && <div>📱 {imeiInfo.brand} {imeiInfo.model}</div>}
                <div>📋 Homologado: <span style={{ color: imeiInfo.homologated === 'COMPATIBLE' ? '#22c55e' : '#ef4444' }}>{imeiInfo.homologated}</span></div>
                {imeiInfo.band28 && <div>📡 Banda 28: <span style={{ color: imeiInfo.band28 === 'SI' ? '#22c55e' : '#ef4444' }}>{imeiInfo.band28}</span></div>}
                {imeiInfo.esim && <div>💳 eSIM: {imeiInfo.esim}</div>}
              </div>
            )}

            {/* ICCID */}
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginBottom: '4px' }}>
              <input
                placeholder="ICCID de la tarjeta SIM"
                type="text"
                value={icc}
                onChange={(e) => {
                  seticc(e.target.value);
                  setIccStatus(null);
                }}
                onBlur={() => { if (icc.length >= 18) validarIcc(icc); }}
                required
                style={{
                  flex: 1,
                  borderColor: iccStatus === 'idle' ? '#22c55e' : iccStatus === 'error' ? '#ef4444' : undefined,
                  borderWidth: iccStatus ? '2px' : undefined,
                }}
              />
              <button
                type="button"
                className="orange-button small-button"
                onClick={() => { if (icc.length >= 14) validarIcc(icc); else toast.warn('Ingresa un ICCID válido'); }}
                disabled={procesando !== null}
                style={{ margin: 0 }}
              >
                ✓
              </button>
              <label className="orange-button small-button" style={{ cursor: 'pointer', textAlign: 'center', margin: 0 }}>
                {procesando === 'icc' ? '⏳...' : '📷'}
                <input
                  type="file"
                  accept="image/*"
                  capture="environment"
                  style={{ display: 'none' }}
                  onChange={(e) => procesarFoto(e, 'icc')}
                />
              </label>
            </div>
            {iccStatus === 'idle' && (
              <div style={{ color: '#22c55e', fontSize: '13px', fontWeight: 'bold', marginBottom: '10px' }}>
                ✅ ICCID válido — Listo para activar
              </div>
            )}
            {iccStatus === 'error' && (
              <div style={{ color: '#ef4444', fontSize: '13px', fontWeight: 'bold', marginBottom: '10px' }}>
                ❌ ICCID debe estar en estatus Idle para continuar
              </div>
            )}

            {procesando && <div style={{ color: '#0056b3', marginTop: '10px', fontWeight: 'bold' }}>⏳ Analizando imagen...</div>}
           
            <div style={{ marginTop: '10px' }}></div>
            <label>
              <input type="checkbox" checked={portabilidad} onChange={(e) => setPortabilidad(e.target.checked)} /> Portabilidad
            </label>
            {portabilidad && (
              <div style={{ marginTop: '10px', padding: '14px', background: '#f0f4f8', borderRadius: '10px', border: '1px dashed #cbd5e1' }}>
                <input
                  placeholder="Número a portar (10 dígitos)"
                  type="tel"
                  maxLength={10}
                  value={numeroPortar}
                  onChange={(e) => setNumeroPortar(e.target.value)}
                  required
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', marginBottom: '10px' }}
                />
                <input
                  placeholder="NIP de portabilidad"
                  type="text"
                  value={nip}
                  onChange={(e) => setNip(e.target.value)}
                  required
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', marginBottom: '10px' }}
                />
                <div style={{ fontSize: '12px', color: '#4b5563', lineHeight: '1.5' }}>
                  <strong>¿Cómo obtener tu NIP?</strong>
                  <p style={{ margin: '6px 0 0 0' }}>Marca al <strong>051</strong> desde la línea que deseas portar y recibirás tu NIP por SMS.</p>
                </div>
              </div>
            )}

<div>
    <h2>Ofertas Disponibles</h2>
    <select id="options" size="8"  width="90%"
   className="responsive-select"
      value={selectedOption} 
      onChange={handleChange2}>
   
      <option value="">--Escoge Oferta--</option>
      {options.map((item) => (
        <option key={item.idoferta_app} value={item.idoferta_app}   >
          $ {item.precio_minorista} {item.descripcion_oferta_comercial} 
        </option>
      ))}
    </select>


  </div>





             <div id="reader" style={{ width: '100%', maxWidth: 400, marginTop: '10px' }}></div>
            <button type="submit" className="orange-button responsive-button" disabled={iccStatus !== 'idle'}>
              {iccStatus !== 'idle' ? 'Valida el ICCID primero' : 'Activar'}
            </button>

            {activacionExito && (
              <div style={{
                marginTop: '16px',
                padding: '20px',
                background: activacionExito === 'activacion' ? '#dcfce7' : '#dbeafe',
                borderRadius: '12px',
                textAlign: 'center',
              }}>
                <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#1b2938', margin: '0 0 8px 0' }}>
                  {activacionExito === 'activacion' ? '✅ Activación en proceso' : '✅ Portabilidad en proceso'}
                </p>
                <p style={{ fontSize: '14px', color: '#4b5563', margin: '0 0 12px 0' }}>
                  Tu línea estará lista en unos minutos.
                  {activacionExito === 'activacion' && ' Recuerda registrar tu IMEI en Altán.'}
                </p>
                {activacionExito === 'activacion' && (
                  <a
                    href="https://rnu.altanredes.com/addomv/vinculatulinea"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="orange-button"
                    style={{ display: 'inline-block', textDecoration: 'none', padding: '10px 20px' }}
                  >
                    Registrar IMEI en Altán
                  </a>
                )}
              </div>
            )}
    
          </form>
        )}

        {activeView === 'campana' && (
          <CampanaPush />
        )}

        {activeView === 'compra_saldo' && (
          <CompraSaldo id_vendedor={id_vendedor} saldo={saldo} />
        )}

        {activeView === 'redes' && (
          <CampanaExterna />
        )}

        {activeView === 'comisiones' && (
          <Comisiones />
        )}

        {activeView === 'ofertas_admin' && (
          <OfertasAdmin />
        )}

        {activeView === 'game' && (
          <MonkeyGame />
        )}

        {activeView === 'game_stats' && (
          <GameStats />
        )}

        {activeView === 'admin_lineas' && esAdmin && (
          <AdminLineas />
        )}

        {activeView === 'crm' && (esAdmin || String(id_vendedor) === '80' || idvendedor_crm) && (
          <CRM id_vendedor={idvendedor_crm || id_vendedor} />
        )}

        {activeView === 'crm_usuarios' && esAdmin && (
          <CrmUsuariosAdmin />
        )}

        {activeView === 'monitoreo' && esAdmin && (
          <CrmMonitoreo />
        )}

        {activeView === 'glosario' && (
          <Glosario />
        )}

      </div>
    </div>
  );
};

export default Dashboard;


